import { createSelector } from 'reselect';
import Immutable, { Map, List } from 'immutable';
import AggregatorTypes from 'constants/aggregator/products';
const { EURO_TEXT } = require('constants/index');

const getAggregatorDataReducer = state => state.aggregatorData;
const getProductReducer = (state, product) => product;

const getAggregatorDataAllProductsByBankCredential = createSelector(
  [getAggregatorDataReducer],
  immAggregatorData => {
    const banks = immAggregatorData.getIn(['data', 'banks'], null);
    const products = immAggregatorData.getIn(['data', 'products'], null);
    const result =
      banks &&
      products &&
      banks.map(bank =>
        bank.update('products', prod =>
          (
            (prod.valueSeq() || [])
              .map(p => p.get('items'))
              .reduce((lv, cv) => (lv ? lv.concat(cv) : cv), null) || []
          ).map(id => products.get(id))
        )
      );

    return result.map(b =>
      b.update('products', p =>
        p && p.groupBy
          ? p
              .groupBy(d => d.get('id', ''))
              .map(d => d.first())
              .valueSeq()
          : new List()
      )
    );
  }
);

const getAggregatorDataBankWithOneTypeProduct = createSelector(
  [getAggregatorDataReducer, getProductReducer],
  (immAggregatorData, productType) => {
    const banks = immAggregatorData.getIn(['data', 'banks'], null);
    const details = immAggregatorData.get('details', null);
    const getProduct = product =>
      immAggregatorData &&
      immAggregatorData.getIn(['data', 'products', product], null) &&
      immAggregatorData
        .getIn(['data', 'products', product], null)
        .mergeIn(['details'], details.get(product, null));

    if (
      AggregatorTypes.LOANSANDMORTGAGES == productType ||
      AggregatorTypes.INVESTMENTS == productType
    ) {
      return (
        banks &&
        productType &&
        banks.map(b =>
          b
            .update(
              'subproducts',
              subproducts =>
                subproducts &&
                subproducts.map(sb =>
                  sb.update('items', item =>
                    item.map(p => getProduct(p)).filter(p => p.get('visible'))
                  )
                )
            )
            .update(
              'products',
              products =>
                products.get(productType) &&
                products
                  .getIn([productType, 'items'])
                  .map(p => getProduct(p))
                  .filter(p => !__CONTACT_CENTER__ || p.get('visible'))
            )
        )
      );
    } else {
      return (
        banks &&
        productType &&
        banks.map(b =>
          b.update('products', products => {
            return (
              products &&
              products.get(productType) &&
              products.getIn([productType, 'items']).map(p => getProduct(p))
            );
          })
        )
      );
    }
  }
);

const getAggregatorDataBankWithOneTypeProductV2 = createSelector(
  [getAggregatorDataReducer, getProductReducer],
  (immAggregatorData, productType) => {
    const banks = immAggregatorData.getIn(['data', 'banks'], null);
    const products = immAggregatorData.getIn(['data', 'products'], null);
    const details = immAggregatorData.get('details', null);
    const getProduct = product =>
      immAggregatorData
        .getIn(['data', 'products', product], null)
        .mergeIn(['details'], details.get(product, null));

    if (
      AggregatorTypes.LOANSANDMORTGAGES == productType ||
      AggregatorTypes.INVESTMENTS == productType
    ) {
      return (
        banks &&
        productType &&
        banks.map(b =>
          b
            .update('subproducts', subproducts =>
              subproducts.map(sb =>
                sb.update('items', item =>
                  item.map(p => getProduct(p)).filter(p => p.get('visible'))
                )
              )
            )
            .update(
              'products',
              products =>
                products.get(productType) &&
                products
                  .getIn([productType, 'items'])
                  .map(p => getProduct(p))
                  .filter(p => !__CONTACT_CENTER__ || p.get('visible'))
            )
        )
      );
      /*                 banks.map(bank =>
                    getSubproductsByProductType(productType, bank)) */
    } else {
      return (
        banks &&
        Object.values(banks.toJS()).map(bank => {
          return (
            bank[productType].items.length && {
              ...bank,
              products:
                products &&
                products.filter(
                  product =>
                    product.get('userBankId') === bank.userBankId &&
                    product.get('type') === productType
                ),
            }
          );
        })
      );
    }
  }
);

const getAggDataTinkBankWithOneTypeProduct = createSelector(
  [getAggregatorDataReducer, getProductReducer],
  (aggregatorDataTink, productType) => {
    const aggDataTink = aggregatorDataTink && aggregatorDataTink.toJS().data;

    const banks = aggDataTink.banks && Object.values(aggDataTink.banks);

    const getSubproductsByProductType = (productType, bank) => {
      let subproducts = [];
      if (productType === 'loansAndMortgages') {
        subproducts = {
          loan: bank.loans.items || [],
          mortgage: bank.mortgages.items || [],
        };
      } else if (productType === 'investments') {
        subproducts = {
          fund: bank.funds.items || [],
          pensionplan: bank.pensionPlans.items || [],
          share: bank.shares.items || [],
        };
      } else {
        subproducts = null;
      }
      return subproducts;
    };

    const mappedAggBanksTink = () => {
      const mappedBanks =
        banks &&
        banks.map(bank => {
          return {
            ...bank,
            products: {
              [productType]:
                productType === 'loansAndMortgages' || productType === 'investments'
                  ? getSubproductsByProductType(productType, bank)
                  : bank[productType],
            },
            subproducts:
              productType === 'loansAndMortgages' ||
              (productType === 'investments' && getSubproductsByProductType(productType, bank)),
          };
        });
      return mappedBanks;
    };

    return mappedAggBanksTink();
  }
);

const getAggregatorBalanceBankByTypeProduct = createSelector(
  [getAggregatorDataReducer, getProductReducer],
  (immAggregatorData, productType) => {
    const banks = immAggregatorData.getIn(['data', 'banks'], null);

    return (
      banks &&
      productType &&
      banks
        .toList()
        .map(b =>
          Map({ name: b.get('name'), balance: b.getIn(['products', productType, 'balance']) })
        )
    );
  }
);

const getAggregatorBalanceBankByTypeProductTink = createSelector(
  [getAggregatorDataReducer, getProductReducer],
  (data, productType) => {
    const aggDataTink = data.toJS().data;
    const banksTink = aggDataTink && Object.values(aggDataTink.banks);
    const emptyBalance = {
      amount: 0,
      currency: EURO_TEXT,
    };

    return (
      banksTink &&
      productType &&
      banksTink.map(bank => ({
        name: bank.name,
        balance: bank[productType].total.visible.balances[0] || emptyBalance,
      }))
    );
  }
);

export const PRODUCTS_NAME = {
  savings: ['accounts', 'deposits'],
  financing: ['cards', { loansAndMortgages: ['loans', 'mortgages'] }],
  investments: ['funds', 'pensionPlans', 'shares'],
};

const getAggregatorDataAllProductsByBankTink = aggregatorData => {
  const banks = aggregatorData && aggregatorData.banks;

  const PRODUCTS_NAME_TINK = {
    savings: ['account', 'deposit'],
    financing: ['card', { loanandmortgage: ['loans', 'mortgages'] }],
    investment: ['funds', 'pensionPlans', 'shares'],
  };

  const result =
    banks &&
    Object.keys(banks)
      .map(item => {
        const productsList = Object.keys(PRODUCTS_NAME_TINK)
          .map(type =>
            PRODUCTS_NAME_TINK[type].map(subtype => {
              if (typeof subtype === 'object') {
                return Object.keys(subtype).map(prodSubtype => {
                  return subtype[prodSubtype].map(
                    product =>
                      banks[item][subtype] && banks[item][subtype][prodSubtype][product].items
                  );
                });
              } else {
                return banks[item][subtype] && banks[item][subtype].items;
              }
            })
          )
          .flat(4)
          .map(product => {
            if (product) {
              product.bank = product.userBankId;
              product.product = product.subproductType;
              product.subproduct = product.subproductType;
              return product;
            }
          });
        banks[item].products = productsList;
        return banks[item];
      })
      .reduce((object, bank) => {
        object[bank.userBankId] = bank;
        return object;
      }, {});

  return Immutable.fromJS(result);
};

const getAggregatorDataBankWithOneTypeProductV4 = createSelector(
  [getAggregatorDataReducer, getProductReducer],
  (immAggregatorData, productType) => {
    const banks = immAggregatorData.getIn(['data', 'banks'], null);
    const details = immAggregatorData.get('details', null);

    const getProduct = product =>
      immAggregatorData &&
      immAggregatorData.getIn(['data', 'products', product], null) &&
      immAggregatorData
        .getIn(['data', 'products', product], null)
        .mergeIn(['details'], details.get(product, null));

    return (
      banks &&
      productType &&
      banks.map(b =>
        b.update('products', products => {
          return (
            products &&
            products.get(productType) &&
            products.getIn([productType, 'items']).map(p => getProduct(p))
          );
        })
      )
    );
  }
);

module.exports = {
  getAggregatorDataAllProductsByBankCredential,
  getAggregatorDataBankWithOneTypeProduct,
  getAggDataTinkBankWithOneTypeProduct,
  getAggregatorBalanceBankByTypeProduct,
  getAggregatorDataBankWithOneTypeProductV2,
  getAggregatorBalanceBankByTypeProductTink,
  getAggregatorDataAllProductsByBankTink,
  getAggregatorDataBankWithOneTypeProductV4,
};
